import follicularChart from "@/female/assets/cycle-based-exp/phase-charts/follicular.webp";
import lutealChart from "@/female/assets/cycle-based-exp/phase-charts/luteal.webp";
import menstruationChart from "@/female/assets/cycle-based-exp/phase-charts/menstruation.webp";
import ovulationChart from "@/female/assets/cycle-based-exp/phase-charts/ovulation.webp";
import { CyclePhases } from "@/female/constants/cycle-based-exp/CyclePhases";

const chartByPhase: Record<CyclePhases, string> = {
    [CyclePhases.Menstrual]: menstruationChart,
    [CyclePhases.Follicular]: follicularChart,
    [CyclePhases.Ovulation]: ovulationChart,
    [CyclePhases.Luteal]: lutealChart,
};

export default chartByPhase;
